import React from "react";
import { Table, Typography } from "antd";
import { round } from "lodash";
import { TitleCamelCase } from "@/utils/string";

type Prop = {
  rank: Record<string, number>;
  ticker: string;
};

export default ({ rank, ticker }: Prop) => {
  const columns = [
    {
      title: "Indicator",
      dataIndex: "indicator",
      key: "indicator"
    },
    {
      title: "Rank",
      dataIndex: "rank",
      key: "rank"
    },
    {
      title: "Score",
      dataIndex: "score",
      key: "score"
    }
  ];

  return (
    <div>
      <Typography.Text strong>{ticker}</Typography.Text>
      <br />
      <Table
        columns={columns}
        size={"small"}
        pagination={false}
        dataSource={Object.entries(rank).map(([k, v], i) => ({
          key: k,
          indicator: TitleCamelCase(k),
          rank: i + 1,
          score: round(v * 100, 2)
        }))}
      />
    </div>
  );
};
